/**
 * 📈 LINE CHART WIDGET
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Renderiza gráficos de línea (TREND, evolución temporal).
 * Simple, sin lógica adicional.
 */

import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { getWidgetSeriesCache } from '../../../../shared/utils/seriesCache';

interface LineChartWidgetProps {
  widget: {
    id: string;
    title: string;
    data: any[];
    metadata?: any;
  };
}

const LineChartWidget: React.FC<LineChartWidgetProps> = ({ widget }) => {
  
  // Detectar campo X (dimensión temporal) y Y (valor)
  const { detectedXField } = getWidgetSeriesCache({
    widgetId: widget.id,
    data: widget.data,
    defaultXField: 'date',
    defaultYField: 'valor',
  });
  const yField = 'valor';
  
  return (
    <div className="chart-widget">
      {/* Título */}
      <div className="chart-title">{widget.title}</div>
      
      {/* Gráfico */}
      <ResponsiveContainer width="100%" height="85%">
        <LineChart data={widget.data} margin={{ top: 10, right: 20, left: 0, bottom: 60 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#334155" opacity={0.3} />
          <XAxis 
            dataKey={detectedXField || 'date'} 
            tick={{ fill: '#94a3b8', fontSize: 11 }}
            stroke="#475569"
            angle={-45}
            textAnchor="end"
            height={60}
            interval={0}
          />
          <YAxis 
            tick={{ fill: '#94a3b8', fontSize: 12 }}
            stroke="#475569"
          />
          <Tooltip 
            contentStyle={{ 
              backgroundColor: '#1e293b', 
              border: '1px solid #334155',
              borderRadius: '8px'
            }}
            labelStyle={{ color: '#e2e8f0' }}
            itemStyle={{ color: '#10b981' }}
          />
          <Line 
            type="monotone" 
            dataKey={yField} 
            stroke="#10b981" 
            strokeWidth={2}
            dot={{ fill: '#10b981', r: 4 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LineChartWidget;
